// extracted by mini-css-extract-plugin
export var container = "_46-0";
export var error = "_46-9";
export var label = "_46-5";
export var light = "_46-6";
export var md = "_46-3";
export var sm = "_46-2";
export var thin = "_46-8";
export var thinBold = "_46-7";
export var vertical = "_46-4";
export var xs = "_46-1";